
import Vue, { PropType } from 'vue'
import { ManualCommunication } from '@/types/GCB2'
import {
    TASKLIST_ACTION_TYPES,
    TASKLIST_COMMUNICATIONS_TYPES,
    TASKLIST_STATUSES,
} from '../../../../vars/GCB2'

import taskListActions from '@/components/chisai/GCB2/taskList/actions'
import ModaDialog from '../taskList/ModaDialog.vue'
import { Project } from '../../../../types/main'
import SendMessageDialog from '../taskList/SendMessageDialog.vue'
import { useGcb2Store } from '@root/src/store/stores/gcb2/gcb2'
import { mapStores } from 'pinia'
import { CONNECTOR_TYPES } from '../../../../vars/general'
import useSendMessageDisabled from '../hooks/useSendMessageDisabled'
import { getActivation } from '@root/src/api/chisai/GCB2'
import { useModalStore } from '@root/src/store/stores/modal'
import { fetchConnector } from '@root/src/api/projects'
import { getAuthStatus, getAuthStatusRework } from '@root/src/api/networkFixer'
import { getConnectionStatus } from '@root/src/api/connectors/yClients'
import cfg from '@root/config'

const CHANNEL_LABELS: Record<string, string> = {
    maxBusiness: 'MAX Business',
    maxBasis: 'MAX',
    maxChannel: 'MAX',
    max: 'MAX',
    telegram: 'Telegram',
    telegramApi: 'Telegram',
    telegramDh: 'Telegram',
    telegramChannel: 'Telegram',
    whatsapp: 'WhatsApp',
    whatsappApi: 'WhatsApp',
    whatsappBasis: 'WhatsApp',
    'dh-whatsapp': 'WhatsApp',
    whatsappChannel: 'WhatsApp',
}

export default Vue.extend({
    components: { ModaDialog, SendMessageDialog },
    props: {
        manualCommunication: { type: Object as PropType<ManualCommunication> },
        type: {
            type: String as PropType<'communication' | 'communication-result' | 'client-settings' | 'all'>,
            default: 'all'
        }
    },
    data: () => ({
        TASKLIST_ACTION_TYPES,
        TASKLIST_STATUSES,
        isPostponeDialog: false,
        isModaDialog: false,
        activeItem: null as null | any,
        changeCommentMode: null as null | 'ONLY_COMMENT' | 'DONT_REMIND',
        isChangeCommentDialog: false,
        isSendMessageDialog: false,
        sendMessageErrors: null as any,
    }),

    computed: {
        ...mapStores(useGcb2Store),
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        isHrProject(): boolean {
            return this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)?.hrProject || false
        },
        showActionModalOnContact(): boolean {
            const gcb2Connector = this.project.connectors.find(
                el => el.connectorType === CONNECTOR_TYPES.GCB2
            )
            return Boolean(gcb2Connector!.showActionModalOnContact)
        },
        userId(): string {
            return this.$store.getters.myUser.sub
        },
        loadingActionsCommunicationIds(): string[] {
            return this.$store.state.GCB2.taskList.loadingActionsCommunicationIds
        },
        callButtonDisabled(): boolean {
            return this.$store.state.GCB2.taskList.disabledCallCommunicationIds.includes(
                this.manualCommunication.communicationId
            )
        },
        buttonsDisabled(): boolean {
            if (this.manualCommunication && !status) {
                return this.loadingActionsCommunicationIds.includes(this.manualCommunication.communicationId)
            } else {
                return false
            }
        },
        sendMessageError(): string | undefined | false {
            if (this.sendMessageErrors) {
                return this.sendMessageErrors.findError(this.manualCommunication)
            }
        },
        modalStore(): any {
            return useModalStore()
        },
    },

    methods: {
        isActionAvailable: taskListActions.isActionAvailable,
        openModaDialog(item: any) {
            this.activeItem = item
            this.isModaDialog = true
        },
        openActionModal(item: ManualCommunication, actionType: string) {
            this.gcb2Store.openActionModal({
                actionType,
                communicationId: item.communicationId,
                opened: true,
            })
        },
        openChangeCommentDialog(item: any) {
            this.activeItem = item
            this.changeCommentMode = 'ONLY_COMMENT'
            this.isChangeCommentDialog = true
        },
        openDontRemindDialog(item: any) {
            this.activeItem = item
            this.changeCommentMode = 'DONT_REMIND'
            this.isChangeCommentDialog = true
        },
        async dontContactAction(item: any) {
            await taskListActions.dontContact(this, item, this.isHrProject)
        },
        async remindAction(item: any) {
            await taskListActions.remind(this, item, this.isHrProject)
        },
        async makeCall(item: any) {
            await taskListActions.makeCall({ vueInstanse: this, item, project: this.project })
        },
        async contact(item: any) {
            if (this.showActionModalOnContact) {
                await this.openActionModal(item, TASKLIST_ACTION_TYPES.CONTACT)
            } else {
                await taskListActions.contact({
                    vueInstanse: this,
                    item,
                    hrProject: this.isHrProject,
                    commType: TASKLIST_COMMUNICATIONS_TYPES.NO,
                })
            }
        },
        openSendMessageDialog(item: any) {
            this.activeItem = item
            this.isSendMessageDialog = true
        },
        async checkBots(item: any) {
            // Отдельная ветка для isChannelsRework
            if (this.project.isChannelsRework) {
                // const sendingSettings = item.extra?.sendingSettings
                // if (!sendingSettings || !sendingSettings.id || sendingSettings.type === 'cascade') {
                //     // Если sendingSettings не указан или это cascade, открываем диалог отправки
                //     this.openSendMessageDialog(item)
                //     return
                // }
                
                // // Находим коннектор по channelId
                // const channelId = sendingSettings.id
                // const channelConnector = this.project.connectors.find(
                //     connector => String(connector.channelId || connector.connectorId) === String(channelId)
                // )
                
                // if (!channelConnector) {
                //     // Если коннектор не найден, открываем диалог отправки
                //     this.openSendMessageDialog(item)
                //     return
                // }
                
                // // Получаем статус авторизации через getAuthStatusRework
                // const { data, error } = await getAuthStatusRework({ 
                //     connectorId: channelConnector.connectorId 
                // })
                
                // if (error) {
                //     // Если ошибка, показываем уведомление
                //     this.$store.dispatch('callNotify', 'Произошла ошибка')
                //     return
                // }
                
                // // Проверяем статус авторизации
                // const status = data.status || data.type || data
                // const isAuthorized = status === 'authorized' || status === 'alreadyLogged' || data.authorized === true
                
                // if (!isAuthorized) {
                //     // Если не авторизовано, показываем модальное окно
                //     this.modalStore.open({
                //         text: `Отсутствует авторизация, отправка сообщений невозможна.\nПовторите авторизацию или выберите другой канал в настройках активации.`,
                //         link: [
                //             `/project/${this.project.id}/connectorSettings/${channelConnector.connectorId}`,
                //         ],
                //         linkText: ['Перейти в настройки канала'],
                //     })
                //     return
                // }
                
                // Если все ок, открываем диалог отправки
                this.openSendMessageDialog(item)
                return
            }
            
            // Старая логика для случая без isChannelsRework
            let preferedBotInActivation = item.extra?.preferedBot?.split('_')[1] || null
            let oldBotDataFromRequest = null
            let newBotDataFromRequest = null
            let yClientsConnectorFromRequest = null
            const oldBotInConnectors = this.project.connectors.find(
                connector => connector.connectorType === 'whatsapp'
            )
            const newBotInConnectors = this.project.connectors.find(
                connector => connector.connectorType === 'whatsappBasis'
            )
            const yClientsConnector = this.project.connectors.find(
                connector => connector.connectorType === 'yClients'
            )
            if (newBotInConnectors) {
                const { data, error } = await getAuthStatus({ connectorId: newBotInConnectors.connectorId })
                if (!error) {
                    newBotDataFromRequest = data
                }
            }
            if (oldBotInConnectors) {
                const { data, error } = await fetchConnector(oldBotInConnectors.connectorId)
                if (!error) {
                    oldBotDataFromRequest = data
                }
            }
            if (yClientsConnector && cfg.botYcAvailable.includes(this.project.id)) {
                const { data, error } = await getConnectionStatus(yClientsConnector.connectorId)
                if (!error) {
                    yClientsConnectorFromRequest = data
                }
            }
            if (
                (preferedBotInActivation === 'whatsappBasis' && newBotDataFromRequest?.alive !== 'auth') ||
                (!preferedBotInActivation && newBotInConnectors && newBotDataFromRequest?.alive !== 'auth' && !oldBotInConnectors) ||
                (!preferedBotInActivation && newBotInConnectors &&
                    oldBotInConnectors &&
                    !oldBotDataFromRequest?.alive &&
                    newBotDataFromRequest?.alive !== 'auth')
            ) {
                this.modalStore.open({
                    text: `Отсутствует авторизация, отправка сообщений невозможна.\nПовторите авторизацию или выберите другого бота в настройках активации.`,
                    link: [
                        `/project/${this.project.id}/connectorSettings/${newBotInConnectors?.connectorId}`,
                    ],
                    linkText: ['Перейти в настройки бота'],
                })
            } else if (
                (preferedBotInActivation === 'whatsapp' && !oldBotDataFromRequest?.alive) ||
                (!preferedBotInActivation && oldBotInConnectors && !oldBotDataFromRequest?.alive && !newBotInConnectors)
            ) {
                this.modalStore.open({
                    text: `Отсутствует авторизация, отправка сообщений невозможна.\nПовторите авторизацию или выберите другого бота в настройках активации.`,
                    link: [
                        `/project/${this.project.id}/connectorSettings/${oldBotInConnectors?.connectorId}`,
                    ],
                    linkText: ['Перейти в настройки бота'],
                })
            } else if ((preferedBotInActivation === 'yClients' && cfg.botYcAvailable.includes(this.project.id) && yClientsConnectorFromRequest?.status !== 'active') ||
                (!preferedBotInActivation && !oldBotInConnectors && !newBotInConnectors && yClientsConnector)
            ) {
                this.modalStore.open({
                    text: `Отсутствует авторизация, отправка сообщений невозможна.\nОбратитесь, пожалуйста, к своему боту.`
                })
            } else if (preferedBotInActivation === 'yClients' && !cfg.botYcAvailable.includes(this.project.id)) {
                this.modalStore.open({
                    text: `Отправка через бота yClients невозможна.\nВыберите, пожалуйста, другого бота.`
                })
             }else {
                this.openSendMessageDialog(item)
            }
        },
    },
    async created() {},
    mounted() {
        let { findError } = useSendMessageDisabled()
        this.sendMessageErrors = { findError }
    },
})
